document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('.wpcf7 form')
  if (!form) return

  const messages = {
    'select-172': '※お問い合わせ項目を選択してください',
    'text-191': '※お名前を入力してください',
    'email-339': '※メールアドレスを入力してください',
    'select-553': '※都道府県を選択してください',
    'textarea-411': '※お問い合わせ内容を入力してください',
    'acceptance-714': '※プライバシーポリシーに同意してください',
  }

  const observer = new MutationObserver(function (mutationsList) {
    // 変更されたノードの中に .wpcf7-not-valid-tip がある場合のみ処理
    for (const mutation of mutationsList) {
      if (mutation.addedNodes.length > 0 || mutation.type === 'childList') {
        form.querySelectorAll('.wpcf7-not-valid').forEach(function (input) {
          const name = input.name
          const wrap = input.closest('.wpcf7-form-control-wrap')
          const tip = wrap?.querySelector('.wpcf7-not-valid-tip')

          if (tip && messages[name] && tip.textContent !== messages[name]) {
            tip.textContent = messages[name]
          }
        })

        // acceptance チェックボックス用（name属性なしのため手動指定）
        const acceptanceWrap = form.querySelector('[data-name="acceptance-714"]')
        const acceptanceTip = acceptanceWrap?.querySelector('.wpcf7-not-valid-tip')
        if (acceptanceTip && acceptanceTip.textContent !== messages['acceptance-714']) {
          acceptanceTip.textContent = messages['acceptance-714']
        }
      }
    }
  })

  observer.observe(form, {
    childList: true,
    subtree: true,
  })
})
